import React, {useState} from "react";
import Table from "react-bootstrap/Table";
import moment from "moment";
import Button from "react-bootstrap/Button";
import {
    adminApi,
    useGetTransfersQuery,
    useUpdateTransfersMutation,
} from "../../../store/reducers/adminApi";
import {Link} from "react-router-dom";
import Form from "react-bootstrap/Form";
import {useAppDispatch} from "../../../hooks/useAppSelector";
import "./transfers.css";

const TRANSFERS_PER_PAGE = 100;

export function Transfers() {
    const dispatch = useAppDispatch();
    const [page, setPage] = useState(1);
    const [statusFilter, setStatusFilter] = useState<"SUCCEEDED" | "FAILED" | "NOT SENT" | undefined>();
    const [dateRange, setDateRange] = useState<{ start?: string; end?: string }>({});

    const {data, refetch, isLoading} = useGetTransfersQuery({
        page,
        limit: TRANSFERS_PER_PAGE,
        status: statusFilter,
        startDate: dateRange.start,
        endDate: dateRange.end,
    });
    const transfers = data?.transfers || [];
    const pagination = data?.pagination;

    const [updateTransfers, updateTransfersResult] = useUpdateTransfersMutation();
    const [loading, setLoading] = useState(false);
    const [modTransfers, setModTransfers] = useState([]);

    const queryParams = {
        page,
        limit: TRANSFERS_PER_PAGE,
        status: statusFilter,
        startDate: dateRange.start,
        endDate: dateRange.end,
    };

    const changeTransferStatus = (transfer, e) => {
        const t = modTransfers.find((t) => transfer.transferID === t.transferID);

        transfer = t ? t : structuredClone(transfer);
        transfer.status = e.target.value;
        if (!t) modTransfers.push(transfer);

        setModTransfers(modTransfers);

        dispatch(
            adminApi.util.updateQueryData("getTransfers", queryParams, (draft) => {
                let draftTransfer = draft.transfers.find((t) => t.transferID === transfer.transferID);
                if (draftTransfer) draftTransfer.status = e.target.value;
            })
        );
    };

    const updateStatus = () => {
        setLoading(true);
        updateTransfers(modTransfers)
            .unwrap()
            .finally(() => {
                refetch();
                setLoading(false);
            });
    };

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex gap-3 align-items-center">
                    <Form.Select
                        value={statusFilter || ""}
                        onChange={(e) => {
                            const value = e.target.value as "SUCCEEDED" | "FAILED" | "NOT SENT" | "";
                            setStatusFilter(value || undefined);
                            setPage(1);
                        }}
                        style={{ width: 'auto' }}
                    >
                        <option value="">All Statuses</option>
                        <option value="SUCCEEDED">Succeeded</option>
                        <option value="FAILED">Failed</option>
                        <option value="NOT SENT">Not Sent</option>
                    </Form.Select>
                    <Form.Control
                        type="date"
                        placeholder="Start Date"
                        onChange={(e) => {
                            setDateRange(prev => ({ ...prev, start: e.target.value || undefined }));
                            setPage(1);
                        }}
                        style={{ width: 'auto' }}
                    />
                    <Form.Control
                        type="date"
                        placeholder="End Date"
                        onChange={(e) => {
                            setDateRange(prev => ({ ...prev, end: e.target.value || undefined }));
                            setPage(1);
                        }}
                        style={{ width: 'auto' }}
                    />
                </div>
                <Button variant="success" onClick={() => updateStatus()} disabled={loading}>
                    Save All
                </Button>
            </div>
            {pagination && (
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="text-muted">
                        Showing {transfers.length} of {pagination.total || 0} transfers
                    </span>
                    <div className="d-flex gap-2 align-items-center">
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => setPage(p => Math.max(1, p - 1))}
                            disabled={page === 1}
                        >
                            Previous
                        </Button>
                        <span className="px-2">Page {page} of {pagination.totalPages || 1}</span>
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => setPage(p => p + 1)}
                            disabled={!pagination.hasMore}
                        >
                            Next
                        </Button>
                    </div>
                </div>
            )}
            <Table striped bordered>
                <thead>
                <tr>
                    <th>Created On</th>
                    <th>Amount</th>
                    <th>To User</th>
                    <th>Status</th>
                </tr>
                </thead>
                <tbody>
                {transfers &&
                    transfers.map((transfer) => {
                        return (
                            <tr key={transfer.transferID}>
                                <td>{moment(transfer.created_at).format("MM-DD-YYYY")}</td>
                                <td>
                                    {(transfer.amount / 100).toFixed(2)}
                                    {transfer.status !== "SUCCEEDED" && <div>
                                        <span>Charged: {transfer.source_charge_amount == null ? "N/A" : (transfer.source_charge_amount / 100).toFixed(2) ?? "N/A"}; Balance: {transfer.stripe_balance == null ? "N/A" :(transfer.stripe_balance / 100).toFixed(2) ?? "N/A"}</span>
                                    </div>}
                                </td>
                                <td>
                                    {transfer.user && (
                                        <Link to={`/psychic/${transfer.user.userID}`}>{transfer.user.username}</Link>
                                    )}
                                </td>
                                <td className="d-flex flex-row">
                                    <Form.Select
                                        onChange={(val) => changeTransferStatus(transfer, val)}
                                        value={transfer.status}
                                        className={transfer.status !== "SUCCEEDED" ? "option-failed" : ""}
                                    >
                                        <option value="SUCCEEDED">Succeeded</option>
                                        <option value="FAILED">Failed</option>
                                        <option value="NOT SENT">Not Sent</option>
                                    </Form.Select>

                                    {transfer.status !== "SUCCEEDED" && <div>
                                        <span className="text-danger">Error: {transfer.error_text}</span>
                                    </div>}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
}
